module.exports = __webpack_public_path__ + "static/media/sample1.fcb703e1.jpg";